<template>
  <GridBase green-energy>
    <h2 v-if="kr">
      <span>sustainability</span>
    </h2>
    <h2 v-else><TextBlock file="green/green-energy-t1" class="pre-line" /></h2>
    <grid-base alpha50 class="sec1">
      <TextBlock file="green/green-energy-t1" class="pre-line" v-if="kr" />
      <TextBlock file="green/green-energy-t2" class="pre-line" v-else />
    </grid-base>
    <section class="sec2">
      <div class="inner-wrap">
        <h4>Go To Green</h4>
        <div class="split-view">
          <h3 v-if="kr"><TextBlock file="green/green-energy-t2" class="pre-line" /></h3>
          <h3 v-else>6.16 Million trees</h3>
          <div>
            <div v-if="kr">
              <div class="txt">
                <p>이산화탄소 배출 감축량</p>
                <p><b>1</b><s>만 톤</s><b>=</b></p>
              </div>
              <div class="txt">
                <p>묘목을 심는 효과</p>
                <p class="tr"><b data-num="0,152">152</b><s>만 그루</s></p>
              </div>
            </div>
            <div v-else>
              <div class="txt">
                <p>Reduction of carbon emission</p>
                <p><b>1</b><s>Million ton</s><b>=</b></p>
              </div>
              <div class="txt">
                <p>The effect of planting trees</p>
                <p class="tr"><b data-num="0,152">0</b><s>Million trees</s></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="graph">
        <p v-if="kr">탄소 배출량 대비 감소분 (tCO2)</p>
        <p v-else>CO2 emissions Vs Reduction in <br class="hidden-md-up" />CO2 emissions(tCO2)</p>
        <Graph :info="co2" />
        <div class="desc" v-if="kr">
          <p>실제 탄소 배출량</p>
          <p>탄소 배출량 감소분</p>
        </div>
        <div class="desc" v-else>
          <p>CO2 emissions <br class="hidden-md-down" />from <br class="hidden-lg-up" />the DATA CENTER GAK</p>
          <p>Reduction in CO2 <br class="hidden-lg-up" />emissons</p>
        </div>
      </div>
      <div class="inner-wrap">
        <p class="p1" v-if="kr">
          데이터센터 각은 자연에너지를 활용하고 에너지 효율이 높은 설비를 개발해 전기 사용량을 줄임으로써 이산화탄소 배출량을 감축하고 있습니다.<br /><br />
          <span class="fs-16">
            &lt;국립산림과학원 발간, 표준탄소 흡수량 기준&gt;<br />
            30년산 소나무의 연간 온실가스 흡수량 : 한 그루당 약 6.6kg<br />
            1톤(1,000kg), 152그루
          </span>
        </p>

        <p class="p1" v-else>
          DATA CENTER Gak is reducing carbon dioxide emissions by utilizing natural energy and developing energy-efficient facilities to reduce electricity use.<br /><br />
          <span class="fs-16">
            &lt;Standard Carbon Absorption Standard for National Institute of Forest Science&gt;<br />
            Annual greenhouse gas absorption of 30-year-old pine trees: 6.6 kg per tree on average.<br />
            1ton(1,000kg), 152 Trees
          </span>
        </p>
      </div>
    </section>
    <grid-base grey class="sec3">
      <div class="inner-wrap">
        <h3>
          PUE 1.09<span v-if="kr">를 <br class="hidden-md-up" />달성하다</span>
        </h3>
        <p>
          <template v-if="kr">
            PUE (Power Effectiveness, 전력 효율 지수)는 데이터센터의 효율을 나타내는 척도입니다. 총 전력량을 IT 장비가 소비하는 전력량으로 나눈 값으로 1에 가까울수록 전력을 많이 절감한 것입니다.
            데이터센터 각은 전기 사용을 대체할 수 있는 친환경 기술과 세심한 운영으로 평균 PUE 1.1을 기록했습니다.
          </template>
          <template v-else>
            PUE (Power Usage Effectiveness) is a value determined by dividing the total amount of power needed in a data center by the amount of power consumed by the IT equipment. It is a metric used
            to determine the power efficiency of a data center. The closer to 1 the PUE, the more efficient the data center. The Data Center Gak achieved an average of 1.1 PUE by efficient operations
            as well as various green technologies.
          </template>
        </p>
        <div class="c1">
          <div class="txt-wrap">
            <div class="txt">
              <p>
                <template v-if="kr">전력 효율 지수</template>
                <template v-else>Power Usage Effectiveness</template>
              </p>
              <p>
                <b>{{ pue.val1_1 }}</b
                ><s class="calibre">PUE</s>
              </p>
            </div>
          </div>
          <div class="graph">
            <dl>
              <div class="graph-box">
                <dt>{{ pue.year1 }}</dt>
                <dd>
                  <div class="bar" :style="{ width: pue1 }"></div>
                  <s>{{ pue.val1_1 }} PUE</s>
                </dd>
              </div>
              <div class="graph-box">
                <dt>{{ pue.year2 }}</dt>
                <dd>
                  <div class="bar" :style="{ width: pue2 }"></div>
                  <s>{{ pue.val1_2 }} PUE</s>
                </dd>
              </div>
              <div class="graph-box">
                <dt>{{ pue.year3 }}</dt>
                <dd>
                  <div class="bar" :style="{ width: pue3 }"></div>
                  <s>{{ pue.val1_3 }} PUE</s>
                </dd>
              </div>
            </dl>
          </div>
        </div>
        <div class="c2">
          <div class="txt-wrap">
            <div class="txt">
              <p>
                <template v-if="kr">전력 사용량</template>
                <template v-else>Electricity Consumption</template>
              </p>
              <p><b>156,875</b><s class="calibre">MWh</s></p>
            </div>
          </div>
          <div class="graph">
            <p>
              <template v-if="kr">2020년 <br />전력 사용량</template>
              <template v-else>Electricity <br />Consumption <br />of 2020</template>
            </p>
            <donut :info="electricity" v-if="electricity" />
            <div class="desc">
              <p>{{ this.kr ? 'IT 장비' : 'IT equipment' }}</p>
              <p>{{ this.kr ? '기계 설비' : 'Facility' }}</p>
              <p>{{ this.kr ? '기타' : 'Others' }}</p>
            </div>
          </div>
        </div>
      </div>
    </grid-base>
    <section class="sec4">
      <div class="inner-wrap">
        <div class="split-view">
          <h3>
            <template v-if="kr">에너지, <br />아껴 쓰고 <br />다시 쓰다</template>
            <template v-else>Reduce, <br />Reuse, <br />Recycle</template>
          </h3>
          <div>
            <div class="txt">
              <p>
                <template v-if="kr">이산화탄소 배출 절감량</template>
                <template v-else>Reduction in carbon <br />dioxide emissions</template>
              </p>
              <p>
                <b class="sm">99.2</b><s>{{ this.kr ? '톤' : 'ton' }}</s>
              </p>
            </div>
          </div>
        </div>
        <p>
          <template v-if="kr">
            절수형 위생 기구를 사용하고 오염이 적은 물을 정수해 소변기와 양변기 물로 재사용합니다. 또한 빗물을 정수해 저장했다가 조경·소방 용수로 활용합니다. 청정 에너지원인 태양광 발전을 통해 연간
            총212.86㎿h(2020년 기준) 전력을 절감했고, 이로써 이산화탄소 배출량을 약 99.2톤 줄였습니다.
          </template>
          <template v-else
            >The Data Center Gak uses water-saving sanitary ware and recycled wastewater for flushing toilets and urinals. It also recycles and stores rainwater for gardening and firefighting. It
            reduced 212.86MWh of energy consumption in 2020 using clean solar energy, which led to a 99.2ton reduction in carbon dioxide emissions.</template
          >
        </p>
      </div>
      <slider :option="{ breakpoints: { 768: { slidesPerView: 'auto', centeredSlides: true } } }">
        <img src="/img/esg/energy-slide-1.png" alt="" class="swiper-slide" />
        <img src="/img/esg/energy-slide-2.png" alt="" class="swiper-slide" />
        <img src="/img/esg/energy-slide-3.png" alt="" class="swiper-slide" />
        <img src="/img/esg/energy-slide-4.png" alt="" class="swiper-slide" />
        <img src="/img/esg/energy-slide-5.png" alt="" class="swiper-slide" />
      </slider>
      <div class="graph">
        <p>{{ this.kr ? '시수 사용량' : 'Potable water consumption' }} (ton)</p>
        <graph :info="water" />
      </div>
      <div class="graph">
        <p>{{ this.kr ? '태양광 발전량' : 'Solar energy consumption' }} (MWh)</p>
        <graph class="line" :info="sun" />
      </div>
    </section>
    <section class="sec5">
      <div class="inner-wrap">
        <h4>LEED PLATINUM</h4>
        <h3 v-if="kr">세계 최고의 <br />친환경 데이터센터</h3>
        <h3 v-else>World-leading <br />Green Data Center</h3>
        <p>
          <template v-if="kr">
            데이터센터 각에는 지속 가능한 미래를 위한 많은 노력과 기술이 담겨 있으며, 이를 인정받아 데이터센터로는 세계 최고 점수인 95점을 받아 LEED 최고등급인 Platinum을 획득하였습니다. (LEED -NC
            Platinum V2009)
          </template>
          <template v-else>
            Data Center Gak exhorted all efforts and technologies for the sustainable future. The eco-friendly way of Gak was acknowledged and become the world’s first data center to acquire the LEED
            platinum, the highest level with the world’s top score (95) for our technical efforts.
            <br />(LEED -NC Platinum V2009)
          </template>
        </p>
        <div class="img">
          <img src="/img/esg/energy-s5-img.png" alt="" />
        </div>
        <p>
          <template v-if="kr">
            <span>LEED (Leadership in Energy and Environmental Design)</span><br />
            는 건물의 입지 선정부터 설계, 건축, 운영까지 전 과정에서 얼마나 친환경적 노력을 기울였는지를 평가하는 세계적인 친환경 건물 인증 제도입니다.
          </template>
          <template v-else>
            <span>LEED (Leadership in Energy and <br class="hidden-md-up" />Environmental Design)</span><br />
            International green building certification system that measures the eco-friendliness of buildings from all aspects, including location selection, design, construction, and operation
          </template>
        </p>
      </div>
    </section>
    <quick-link>
      <quick-link-item><router-link to="/data/our-idea">Our Idea</router-link></quick-link-item>
      <quick-link-item
        ><router-link to="/tech/gak-chuncheon">GAK <br class="hidden-md-up" />Chuncheon</router-link></quick-link-item
      >
    </quick-link>
  </GridBase>
</template>
<script>
import _ from 'lodash';
import GridBase from '../../components/GridBase';
import QuickLink from '@/views/components/QuickLink';
import QuickLinkItem from '@/views/components/QuickLinkItem';
import Slider from '@/views/components/Slider';
import Graph from '@/views/components/Graph';
import Donut from '@/views/components/Donut';
import TextBlock from '@/views/components/TextBlock';
import energyData from '@/data/archive/energy';

export default {
  name: 'green-energy',
  components: { TextBlock, Donut, Graph, Slider, QuickLinkItem, QuickLink, GridBase },
  data() {
    return {
      co2: {},
      water: {},
      sun: {},
      electricity: null,
      pue: {},
      pue1: '100%',
      pue2: '100%',
      pue3: '100%'
    };
  },
  mounted() {
    this.co2 = _.find(energyData, row => row.id === 'co2');
    this.water = _.find(energyData, row => row.id === 'water');
    this.sun = _.find(energyData, row => row.id === 'sun');
    this.electricity = _.find(energyData, row => row.id === 'electricity');
    this.pue = _.find(energyData, row => row.id === 'pue');
    const max = Math.max(this.pue.val1_1, this.pue.val1_2, this.pue.val1_3);
    this.pue1 = `${(this.pue.val1_1 / max) * 100}%`;
    this.pue2 = `${(this.pue.val1_2 / max) * 100}%`;
    this.pue3 = `${(this.pue.val1_3 / max) * 100}%`;
  }
};
</script>
